import Modal from '@components/v2/ui/Modal/Modal';
import { ParamValues } from '../../../../../components/Crud/useFilter.types';
import LangEnum from '../../../../../lang/LangEnum';
import { UsedInOfflineMode } from '../../../../offline/types/UsedInOfflineMode';
import { useTranslation } from '../../../../translation/TranslationContext';
import CopyOrderSuggestedOrDraftModal from '../../../copy-order/CopyOrderSuggestedOrDraftModal';
import ExportOrderModal from '../../../export/V2/ExportOrderModal';
import { UseOrderListMassActionsResult } from '../orderListPage.types';

interface OrderListMassActionModalsProps extends UsedInOfflineMode {
  massActionsState: UseOrderListMassActionsResult;
  reloadList: (params?: ParamValues) => void;
}

const OrderListMassActionModals = ({
  massActionsState,
  reloadList,
  isOfflineMode = false,
}: OrderListMassActionModalsProps) => {
  const { translate } = useTranslation();
  const {
    massActionLabel,
    massActionDenyLabel,
    massActionAcceptLabel,
    handleConfirmMassAction,
    renderCustomAlertContent,
    openMassActionsAlertModal,
    handleCloseMassActionsAlertModal,
    openMassActionExportModal,
    setOpenMassActionExportModal,
    exportScope,
    copyOrdersBatchType,
    setCopyOrdersBatchType,
    batchUpdateOrdersParams,
  } = massActionsState;

  return (
    <>
      {openMassActionExportModal && exportScope && (
        <ExportOrderModal
          isOfflineMode={isOfflineMode}
          open={openMassActionExportModal}
          onClose={() => setOpenMassActionExportModal(false)}
          exportScope={exportScope}
        />
      )}
      {copyOrdersBatchType && (
        <CopyOrderSuggestedOrDraftModal
          isOpen
          onClose={() => setCopyOrdersBatchType(undefined)}
          reload={reloadList}
          type={copyOrdersBatchType}
          batchUpdateOrdersParams={batchUpdateOrdersParams}
        />
      )}
      <Modal
        isOpen={openMassActionsAlertModal}
        size="standard"
        onClose={handleCloseMassActionsAlertModal}
        header={{
          title: translate(LangEnum.ORDER_MASS_ACTIONS_ALERT_MESSAGE, { massActionLabel }),
        }}
        footer={{
          primaryAction: {
            label: massActionAcceptLabel ?? LangEnum.GLOBAL_YES,
            onClick: handleConfirmMassAction,
          },
          secondaryAction: {
            label: massActionDenyLabel ?? LangEnum.GLOBAL_NO,
            onClick: handleCloseMassActionsAlertModal,
          },
        }}
      >
        {renderCustomAlertContent()}
      </Modal>
    </>
  );
};

export default OrderListMassActionModals;
